import { render, staticRenderFns } from "./CaracteristicaForm.vue?vue&type=template&id=6cd1bc61"
import script from "./CaracteristicaForm.vue?vue&type=script&lang=js"
export * from "./CaracteristicaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports